module.exports = __webpack_public_path__ + "static/media/plus-black.6febc609.svg";